export const protocol = "https";
export const host = "api.elpixie.com";
// export const host = "api.development.elpixie.com";
// export const host = "192.168.29.98";
export const port = "";
export const trailUrl = "";